import buttonVariables from './button-variables';
import checkboxVariables from './checkbox-variables';
import containerVariables from './container-variables';
import dropdownVariables from './dropdown-variables';
import fontFamilyVariables from './font-family-variables';
import hintVariables from './hint-variables';
import inputVariables from './input-variables';
import labelVariables from './label-variables';
import linkButtonVariables from './link-button-variables';
import linkVariables from './link-variables';
import radioSelectVariables from './radio-select-variables';

const variablesMap = new Map<string, { var: string; cssVar?: string; assignDefault?: string[] }>([
  [
    'borderRadius',
    {
      var: 'borderRadius.default',
      assignDefault: [
        'buttonBorderRadius',
        'containerBorderRadius',
        'inputBorderRadius',
        'dropdownBorderRadius',
        'radioSelectBorderRadius',
        'checkboxBorderRadius',
      ],
    },
  ],
  [
    'colorError',
    {
      var: 'color.error',
      cssVar: 'text-color-error',
      assignDefault: ['borderColorError', 'hintErrorColor', 'linkButtonDestructiveColor'],
    },
  ],
  [
    'colorWarning',
    {
      var: 'color.warning',
      cssVar: 'text-color-warning',
      assignDefault: [],
    },
  ],
  [
    'colorSuccess',
    {
      var: 'color.success',
      cssVar: 'text-color-success',
      assignDefault: [],
    },
  ],
  [
    'colorAccent',
    {
      var: 'color.accent',
      cssVar: 'text-color-accent',
      assignDefault: [
        'linkColor',
        'linkButtonColor',
        'linkButtonHoverColor',
        'linkButtonActiveColor',
        'radioSelectSelectedColor',
        'radioSelectSelectedBorderColor',
        'radioSelectComponentsIconSelectedBg',
        'checkboxCheckedBg',
      ],
    },
  ],
  [
    'borderColorError',
    {
      var: 'borderColor.error',
      cssVar: 'border-color-error',
      assignDefault: ['inputErrorBorderColor'],
    },
  ],
  ...fontFamilyVariables,
  ...containerVariables,
  ...buttonVariables,
  ...checkboxVariables,
  ...dropdownVariables,
  ...hintVariables,
  ...inputVariables,
  ...labelVariables,
  ...linkButtonVariables,
  ...linkVariables,
  ...radioSelectVariables,
]);

export default variablesMap;
